export default __webpack_public_path__ + "static/media/ADD3.93803262.jpg";